import { render, staticRenderFns } from "./DownPaymentBox.vue?vue&type=template&id=60020558&scoped=true"
import script from "./DownPaymentBox.vue?vue&type=script&lang=js"
export * from "./DownPaymentBox.vue?vue&type=script&lang=js"
import style0 from "./DownPaymentBox.vue?vue&type=style&index=0&id=60020558&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60020558",
  null
  
)

export default component.exports